/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_Palette_AppliedInputs */



/**
* | output |
* | --- |
* | "Colours were taken from the template." |
*
* @param {Presentation_Template_Master_Palette_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_palette_applied = /** @type {((inputs?: Presentation_Template_Master_Palette_AppliedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_Palette_AppliedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Farben wurden aus der Vorlage übernommen.")
	return /** @type {LocalizedString} */ ("Colours were taken from the template.")
});